// extracted by mini-css-extract-plugin
module.exports = {"allMarkets":"AllMarkets_allMarkets__1V5wY"};